import React from 'react'
import './Onoffer.css'
import {Link} from 'react-router-dom'
import {BsArrowRight} from 'react-icons/bs'

const Onoffer = () => {
  return (
        <div className='emptyoffer'>
          <h2 className='empty'>Thank you for visiting our "On Offer" page. While we don't have current promotions,
            we're here to provide you with valuable content and information. Please feel free to explore our website, 
            and if you have any questions or need assistance, don't hesitate to reach out to us.
          </h2>
          <p>We look forward to serving you and keeping you informed 
             about any future offerings from <span>Top Fashion<span/></span>.
          </p>
          <div className='links'>
             <Link to='/' className='link'>Home</Link>
             <Link to='/shop' className='link'>Shop Now <BsArrowRight/> </Link>
             <Link to='/contact' className='link'>Contact Us</Link>
          </div>
        </div>
  )
}

export default Onoffer